import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button } from '@mui/material';

import { parseSalesforceHtmlLink } from './parseSalesforceHtmlLink';

interface Props {
  label?: string;
  value: string | null | undefined;
}

export default function SalesforceLinkButton({ label, value }: Props) {
  const link = parseSalesforceHtmlLink(value);

  if (!link) {
    return <>—</>;
  }

  return (
    <Button
      component="a"
      href={link.href}
      rel="noopener noreferrer"
      target="_blank"
      size="small"
      startIcon={<OpenInNewIcon fontSize="inherit" />}
      sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
      variant="outlined"
      onClick={(event) => event.stopPropagation()}
    >
      {label ?? link.label ?? 'Open link'}
    </Button>
  );
}
